var Modal = /** @class */ (function () {
    function Modal(toggleElements, modal) {
        var _this = this;
        this.toggleElements = toggleElements;
        this.modal = modal;
        this.open = function () {
            _this.modal.classList.add('open');
            _this.modal.scrollTo(0, 0);
            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', _this.closeOnKeyDown);
        };
        this.close = function () {
            _this.modal.classList.remove('open');
            document.body.style.overflow = null;
            document.removeEventListener('keydown', _this.closeOnKeyDown);
        };
        this.closeOnKeyDown = function (event) {
            if (event.key === 'Escape')
                _this.close();
        };
        this.toggleElements = toggleElements;
        this.modal = modal;
        this.toggleElements.forEach(function (element) {
            element.addEventListener('click', _this.open);
        });
        this.modal.querySelector('.modal-overlay').addEventListener('click', this.close);
        this.modal.querySelector('.modal-close').addEventListener('click', this.close);
    }
    return Modal;
}());
export { Modal };
